const footer_links = [
	{
		title: "SFBW 2018",
		link: "/sfbw2018",
	},
	{
		title: "SFBW 2019",
		link: "/sfbw2019",
	},
	{
		title: "Contact Us",
		link: "mailto:info@sfblockchainweek.io",
	},
];

export default footer_links;
